import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(() => createStyles({
  anchorLink: {
    textDecoration: 'none'
  },
  ctaButton: {
    padding: '6px 3rem',
    fontSize: '14px',
    textTransform: 'uppercase'
  },
  preventClick: {
    cursor: 'auto',
    pointerEvents: 'none',
    '&:hover': {
      boxShadow: 'none'
    }
  }
}));
